<template>
  <v-container :class="containerClass" fluid>
    <holiday-form mode="add" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('holidays.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new holiday</h2>
        </div>
      </template>
    </holiday-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import HolidayForm from '@components/Holiday/Form'
export default {
  components: {
    HolidayForm,
  },
  layout: LayoutDashboard,
  methods: {
    onCancel() {
      window.location.href = this.$route('holidays.index')
    },
  },
}
</script>
